import workDaysReducer from "../workDaysReducer";
import paramAvantagesReducer from "../paramAvantagesReducer";
import attestationsReducer from "../attestationsReducer";
import leaveBalanceReducer from "../leaveBalanceReducer";
import timesheetWorkflowReducer from "../timesheetWorkflowReducer";
import workflowValidationReducer from "../workflowValidationReducer";
import paramCongesReducer from "../paramCongesReducer";
import workflowReducer from "../workflowReducer";
import sectionReducer from "../sectionReducer";
import changeRequestReducer from "../changeRequestReducer";
import leaveRequestsReducer from "../leaveRequestsReducer";
import noteDeFraisReducer from "../noteDeFraisReducer";
import ordreMissionReducer from "../ordreMissionReducer";
import avanceReducer from "../avanceReducer";
import timesheetReducer from "../timesheetReducer";
import avanceRequestsReducer from "../avanceRequestReducer";
import missionRequestsReducer from "../missionRequestReducer";
import noteDeFraisRequestsReducer from "../noteDeFraisRequestReducer";
import mesAvantagesReducer from "../mesAvantagesReducer";
import offboardingReducer from "../offboardingReducer";
import payrollReducer from "../payrollReducer";

const grhReducers = {
  workDays: workDaysReducer,
  paramAvantagessociaux: paramAvantagesReducer,
  attestations: attestationsReducer,
  leaveBalance: leaveBalanceReducer,
  timesheetWorkflow: timesheetWorkflowReducer,
  workflowValidation: workflowValidationReducer,
  paramConges: paramCongesReducer,
  userWorkflows: workflowReducer,
  userSections: sectionReducer,
  userChangeRequests: changeRequestReducer,
  leaveRequests: leaveRequestsReducer,
  noteDeFrais: noteDeFraisReducer,
  ordreMission: ordreMissionReducer,
  avance: avanceReducer,
  timesheet: timesheetReducer,
  avanceRequests: avanceRequestsReducer,
  missionRequests: missionRequestsReducer,
  noteDeFraisRequests: noteDeFraisRequestsReducer,
  mesAvantages: mesAvantagesReducer,
  offboarding: offboardingReducer,
  payroll: payrollReducer,
};

export default grhReducers;
